import * as actions from 'redux/actions/selection.actions'
import * as tagsActions from 'redux/actions/domainTags.actions'

const initialState = {
  table: {
    selection: []
  },
  tags: {
    selectAll: false,
    selection: []
  }
}

const selectionReducer = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case actions.setSelection.type:
      return {
        ...state,
        table: {
          selection: payload.selection
        }
      }

    case actions.clearSelection.type:
      return {
        ...state,
        table: {
          ...state.table,
          selection: []
        }
      }

    case actions.tagSet.type: {
      return {
        ...state,
        tags: {
          ...state.tags,
          selection: payload.selection
        }
      }
    }

    case tagsActions.addDomainTag.type:
    case tagsActions.addTagsToKeywords.type:
    case tagsActions.deleteTagsFromKeywords.type:
    case tagsActions.removeDomainTag.type:
    case tagsActions.updateDomainTag.type:
    case actions.tagDeselectAll.type:
      return {
        ...state,
        tags: {
          ...state.tags,
          selection: []
        }
      }

    case actions.tagToggleAll.type:
      return state

    case 'ROUTE_CHANGE':
    case actions.resetSelections.type:
      return {
        ...initialState
      }

    default:
      return state
  }
}

export default selectionReducer
